import { useImageFallback } from "../useImageFallback";
import { ProductMediaPlaceholder } from "./ProductMediaPlaceholder";

export interface ProductThumbProps {
  src: string | undefined;
  /**
   * Nombre del producto. Va como texto alternativo SOLO si la miniatura
   * es lo único que identifica la fila; cuando el nombre se lee al lado
   * —el caso del carrito— se pasa `decorative` y la imagen se calla, para
   * que el lector de pantalla no repita el mismo nombre dos veces.
   */
  name: string;
  decorative?: boolean;
}

/**
 * La miniatura cuadrada de un producto: la fila del carrito, y cualquier
 * lista compacta que venga después.
 *
 * Cuadrada y no 3:4 como la tarjeta: en una fila de lista, un rectángulo
 * alto empuja el alto de la fila y deja huecos a los lados del texto.
 */
export function ProductThumb({ src, name, decorative = false }: ProductThumbProps) {
  const { showImage, onError } = useImageFallback(src);

  return (
    <div className="relative h-20 w-20 shrink-0 overflow-hidden rounded-ds-md border border-ds-border bg-ds-mist/50">
      {showImage ? (
        <img
          src={src}
          alt={decorative ? "" : name}
          {...(decorative ? { "aria-hidden": true } : {})}
          loading="lazy"
          onError={onError}
          className="h-full w-full object-cover"
        />
      ) : (
        <ProductMediaPlaceholder size="sm" />
      )}
    </div>
  );
}
